import '../../styles/views/contacts.scss';
import '../../styles/partials/social-share42.scss';
var moduleName = 'staticPage';
angular.module(moduleName, []).controller('StaticPageCtrl', function () {});
export default moduleName;